import { render } from "./RestorantCard.vue?vue&type=template&id=051d7832&ts=true"
import script from "./RestorantCard.vue?vue&type=script&lang=ts"
export * from "./RestorantCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__